import React, { Component } from 'react';
import { translate } from "../APIs";

export const defaultMessages = {
    CLOUD_SERVICE: "Cloud Services",
    B_ACCOUNT: "B Account",
    AUTHORIZATION: "Authorization",
    REPORT: "REPORT",
    JSON_EDITOR: "JSON EDITOR",
    ACCOUNT_LIST: "ACCOUNT LIST",
    USER: "User",
    EMAIL: "Email",
    BUSINESS: "Business",
    ROLES: "Roles",
    MERCHANT_ID: "Merchant Id",
    STATUS: "Status",
    EMAIL_ADDR: "Email Address",
    PHONE: "Phone",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    MENU: "Menu",
    MERCHANTS: "Merchants",
    SERVICES: "Services",
    INVITE: "Invite",
    SAVE: "Save",
    CANCEL: "Cancel",
    SEND: "Send",
    RESEND: "Resend",
    DELETE: "Delete",
    PENDING: "Pending",
    ACTIVE: "Active",
    ACCOUNT: "ACCOUNT",
    SETTINGS: "Settings",
    MANAGE_ACCOUNTS: "manage accounts",
    MERCHANT_MANAGEMENT: "Merchant Management",
    CLOUD_REPORT: "Cloud Report",
    DELETE_ACCOUNT_WARNING: "Are you sure to delete the account",
    CREATE_NEW_SET: "Create a new set",
    SEND_VERIFICATION: "SEND VERIFICATION",
    SEND_VERIFICATION_EMAIL: "Send Verification Email",
    ENTER_USERNAME: "Please enter username, email or phone number",
    CHANGE_PWD_SENT: "The link to change password has been sent to your email.",
    VERIFICATION_SENT: "The verification code has been sent to",
    NEW_PWD: "New Password",
    CONFIRM_PWD: "Confirm Password",
    CONFIRM: "Confirm",
    CHANGE_PWD: "Change Password",
    PASSWORD: "Password",
    TRANSLATION: "Translation",
    SIGN_IN: "sign in",
    VERIFY: "Verify",
    VERIFICATION: "Verification",
    FORGET_PASSWORD: "Forget password",
    PWD_NOT_MATCH: "Passwords do not match",
    PWD_RESET_SUCCESS: "Password reset successfully. You will be redirected to login",
    PWD_FORGET_SUCCESS: "Password reset successfully",
    PWD_MUST: "The password must have",
    PWD_LENGTH_RULE: "8 characters",
    PWD_NUMBER_RULE: "numbers",
    PWD_UPPERCASE_RULE: "uppercase letters",
    PWD_LOWERCASE_RULE: "lowercase letters",
    NONE_EMPTY_GROUP_RULE: "Groups must have at least one merchant",
    DUPLICATE_GROUP_NAME: "Group name already exists",
    MERCHANT_PAGE_WELCOME: "Welcome back to your merchant managment platform",
    BUSINESS_IS_LOADING: "YOUR BUSINESS DATA IS LOADING...",
    NO_BUSINESS: "YOU DON'T HAVE ANY BUSINESS",
    CHOOSE: "CHOOSE",
    THE_BUSINESS: "THE BUSINESS", 
    CHOOSE_BUSINESS: "CHOOSE YOUR BUSINESS",
    MERCHANTS_LISTS: "Merchant Lists",
    STRUCTURES: "Structures",
    CREATE: "Create",
    EDIT_MERCHANT_GROUP: "Edit Merchant Group",
    CREATE_MERCHANT_GROUP: "Create New Group",
    GROUP_NAME: "Group Name",
    GROUPS: "Groups",
    MIDS: "MIDs",
    ALIAS_FAILURE: "Create alias failure",
    ALIAS_EMPTY_ERROR: "The alias can not be empty",
    DELETE_GROUP_FAIL: "Delete merchant group failure",
    CREATE_NEW_GROUP_FAIL: "Create new merchant group failure",
    GROUP_RULE: "Please select at least one merchant or one group",
    EMPTY_NAME_ERROR: "Group name can not be empty",
    UPDATE_GROUP_FAIL: "Update merchant group failure",
    FETCH_MERCHANTS_FAIL: "Sorry, can not fetch authorized merchants",
    VERIFICATION_SENT_SUCCESS: "The verifcation has been sent",
    SAME_EMAIL_ERROR: "Same email/phone as the current email/phone",
    USED_EMAIL_ERROR: "The email/phone has been used",
    INVALID_EMAIL: "Invalid email",
    INVALID_VERIFY: "Invalid verification code",
    EXPIRED_VERIFY_CODE: "Expired verification code",
    REPORT_MENU: "Report Menu",
    CREATED: "Created",
    // MFA Translations
    MFA_TITLE: "Two-Factor Authentication",
    MFA_DESCRIPTION: "We've sent a verification code to your phone number.",
    VERIFICATION_CODE: "Verification Code",
    VERIFICATION_CODE_PLACEHOLDER: "Enter 6-digit code",
    VERIFICATION_CODE_ERROR: "The code is incorrect, please try again",
    RESEND_CODE: "Resend Code",
    BACK_TO_SIGN_IN: "Back to Sign In",
    // Signin Error Translations
    USERNAME_PASSWORD_WRONG: "The username or password is wrong",
    USERNAME_NOT_EXIST: "The username does not exist or is not verified. Please check your username and try again.",
    AUTHENTICATION_FAILED: "Authentication failed. Please try again.",
    PLEASE_INPUT_EMAIL_PHONE: "Please input email or phone.",
    INVITATION_NOT_CONFIRMED: "You haven't confirmed the invitation yet. Please use the invitation link to change the temporary password. If you cannot find the invitation link, please contact customer service to resend.",
    NO_VERIFIED_CONTACT: "You don't have any verified phone or email. Please contact customer service.",
    USER_NOT_EXISTS: "User not exists. Please check the email or phone number.",
    TEMP_PASSWORD_MESSAGE: "You are using the temporary password. Please reset your password for your account security.",
    ALREADY_CHANGED_PASSWORD: "You have already changed your temporary password. You will be redirected to the login page. Please use the forget password link if you cannot find your password.",
    WELCOME_TO_MENUSIFU: "Welcome to MenuSifu",
    BY_LOGGING_IN: "By logging in, you agree to Menusifu's",
    TERMS_OF_USE: "Terms of Use",
    AND: "and",
    PRIVACY_POLICY: "Privacy Policy"
}

class MultilingualController {
    constructor(defaultMessages) {
        this.defaultPool = defaultMessages;
        this.locale = "en-US";
        this.messagePool = defaultMessages;
    }
    setLocale = async (locale) => {}
}

export const multilingualController = {
    defaultPool: defaultMessages,
    locale: "en-US",
    messagePool:defaultMessages,
    setLocale: () => {}
}

export const MessageContext = React.createContext(multilingualController);

export const withMultiLanguagesConsumer = (Children) => {
    return (props) => (
        <MessageContext.Consumer>
            {(contextProps) => (
                <Children {...props} {...contextProps}/>
            )}
        </MessageContext.Consumer>
    )
}

export function withMultiLanguagesProvider(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                defaultPool: defaultMessages,
                locale: window.localStorage.getItem("locale") || "en-US",
                messagePool: defaultMessages,
                setLocale: this.setLocale
            }
        }
    
        setLocale = async (locale) => {
            if (locale == this.state.locale) return; 
            console.log('Setting locale to:', locale);
            window.localStorage.setItem("locale", locale);
            const newPool = await this.getMessagePool(locale);
            console.log('New message pool:', newPool);
            this.setState({
                locale, messagePool: newPool
            })
        }

        getMessagePool = async (locale) => {
            const messages = Object.keys(defaultMessages).map(k => defaultMessages[k]);
            let dict = {};
            
            try {
                const res = await translate(messages, locale);
                dict = res.data.result || {};
            } catch (error) {
                console.warn('Translation API failed, using manual translations only:', error);
                dict = {};
            }
            
            // Manual translations for commonly untranslated messages
            const manualTranslations = {
                "zh-CN": {
                    "Two-Factor Authentication": "双重验证",
                    "We've sent a verification code to your phone number.": "我们已向您的手机号码发送验证码。",
                    "Verification Code": "验证码",
                    "Enter 6-digit code": "输入6位验证码",
                    "Verify": "验证",
                    "Resend Code": "重新发送验证码",
                    "Back to Sign In": "返回登录",
                    "The code is incorrect, please try again": "验证码错误，请重试",
                    "Welcome to MenuSifu": "欢迎使用MenuSifu",
                    "Forget password": "忘记密码",
                    "sign in": "登录",
                    "By logging in, you agree to Menusifu's ": "登录即表示您同意MenuSifu的",
                    "Terms of Use": "使用条款",
                    " and ": "和",
                    "Privacy Policy": "隐私政策"
                },
                "zh-HK": {
                    "Two-Factor Authentication": "雙重驗證",
                    "We've sent a verification code to your phone number.": "我們已向您的手機號碼發送驗證碼。",
                    "Verification Code": "驗證碼",
                    "Enter 6-digit code": "輸入6位驗證碼",
                    "Verify": "驗證",
                    "Resend Code": "重新發送驗證碼",
                    "Back to Sign In": "返回登錄",
                    "The code is incorrect, please try again": "驗證碼錯誤，請重試",
                    "Welcome to MenuSifu": "歡迎使用MenuSifu",
                    "Forget password": "忘記密碼",
                    "sign in": "登錄",
                    "By logging in, you agree to Menusifu's ": "登錄即表示您同意MenuSifu的",
                    "Terms of Use": "使用條款",
                    " and ": "和",
                    "Privacy Policy": "隱私政策"
                }
            };
            
            let newPool = {};
            for (let key in defaultMessages) {
                const originalText = defaultMessages[key];  // Use defaultMessages directly instead of this.state.defaultPool
                // First try to get from backend translation
                let translatedText = dict[originalText];
                
                // If not found in backend translation OR backend returned the same English text, try manual translations
                if ((!translatedText || translatedText === originalText) && manualTranslations[locale] && manualTranslations[locale][originalText]) {
                    translatedText = manualTranslations[locale][originalText];
                    console.log(`Using manual translation for "${originalText}": "${translatedText}"`);
                }
                
                // Fallback to original text if no translation found
                newPool[key] = translatedText || originalText;
            }
            console.log('Final message pool for locale', locale, ':', newPool);
            return newPool;
        }

        async componentDidMount() {
            const { locale } = this.state;
            console.log('MultiLanguageProvider componentDidMount - locale from localStorage:', locale);
            if (locale != "en-US") {
                console.log('Loading translations for locale:', locale);
                const newPool = await this.getMessagePool(locale)
                console.log('Setting messagePool in componentDidMount:', newPool);
                this.setState({ messagePool: newPool })
            } else {
                console.log('Using default English messages');
            }
        }
        
        render() {
            return (
                <MessageContext.Provider value={this.state}>
                    <WrappedComponent {...this.props}/>
                </MessageContext.Provider>
            )
        }
    }
}